{
  "Account": {
    "AcceptTerms": "Ich akzeptiere die <a href=\"pdf/Nutzungsbestimmungen.pdf\" target=\"_blank\">Nutzungsbedingungen</a>",
    "ConfirmEmail": {
      "ConfirmationInProgress": "Ihre E-Mail wird bestätigt, bitte warten.",
      "ConfirmationTokenFailed": "Der Link ist in der Zwischenzeit abgelaufen. Bitte fordern Sie einen neuen Link an.",
      "EmailConfirmed": "Ihre E-Mail wurde bestätigt. Sie können sich nun in die Applikation einloggen.",
      "ResendConfirmationEmailButton": "Link erneut schicken.",
      "Title": "E-Mail bestätigen"
    },
    "Errors": {
      "EmailInvalid": "Bitte eine gültige E-Mail-Adresse eingeben",
      "EmailRequired": "Bitte E-Mail-Adresse eingeben",
      "EmployedFromRequired": "Bitte \"Angestellt von\" ausfüllen",
      "FirstNameRequired": "Bitte geben Sie Ihren Vornamen ein",
      "FunctionRequired": "Bitte Facharzttitel eingeben",
      "GlnRequired": "GLN wird benötigt für Registrierung als Arzt.",
      "LastNameRequired": "Bitte geben Sie Ihren Namen ein",
      "PasswordConfirmRequired": "Bitte das Passwort bestätigen",
      "PasswordRequired": "Bitte Passwort wählen",
      "PasswordsDoNotMatch": "Die Passwörter stimmen nicht überein",
      "TermsAcceptedRequired": "Sie müssen die Nutzungsbedingungen akzeptieren",
      "UserNameRequired": "Bitte einen Benutzernamen eingeben"
    },
    "ForgotPassword": {
      "PasswordForgottenTitle": "Passwort vergessen"
    },
    "HinLinked": {
      "BackToDashboard": "Zurück zum Dashboard",
      "Cancelled": "HIN-Login Verknüpfung wurde abgebrochen.",
      "Error": "Ihr HIN-Login konnte nicht verknüpft werden.",
      "Success": "HIN-Login erfolgreich verknüpft. Ab sofort können Sie sich mit HIN anmelden."
    },
    "Login": {
      "ForgotPasswordTitle": "Passwort vergessen",
      "LoginTitle": "Anmeldung",
      "RegistrationTitle": "Registrierung"
    },
    "Register": {
      "AccreditedInfo": "Akkreditiert bei (Mehrfachauswahl möglich)",
      "AccreditedInfoReadonly": "Automatisch akkreditiert",
      "CityPlaceholder": "Ort",
      "Delegate": "Stellvertretung",
      "Doctor": "Belegarzt",
      "EmailPlaceholder": "E-Mail-Adresse",
      "ExplanationPractice": "Angabe der Praxis bzw. des Instituts, an welchem der Belegarzt selbständig erwerbend oder im Drittanstellungsverhältnis tätig ist.",
      "ExplanationPracticeTitle": "Erläuterung",
      "FirstnamePlaceholder": "Vorname",
      "FormDataForDelegates": "Für Stellvertretungen: Notwendige Daten",
      "FormDataForDoctors": "Für Ärzte: Notwendige Daten für Verträge",
      "FunctionHint": "<a href=\"https://www.healthreg-public.admin.ch/medreg/search\" target=\"_blank\">Medizinalberufregister</a>",
      "FunctionPlaceholder": "Facharzttitel (alle) oder Funktion",
      "GlnObligatory": "<b>Pflichtfeld. Bitte die persönliche GLN erfassen.</b>",
      "GlnPlaceholder": "Persönliche GLN",
      "InstitutionGroupAdmin": "Klinikgruppenadmin",
      "InstitutionGroupAdminOrganisation": "Admin der Klinikgruppe",
      "InstitutionNamePlaceholder": "Praxis- / Institutsname",
      "Insurance": "Versicherung",
      "InsuranceContractManager": "Vertragsmanager",
      "InsuranceFunctionSelection": "Bitte wählen Sie Ihre Funktion aus",
      "InsurancePlaceholder": "Versicherung auswählen",
      "InsuranceReviewer": "Leistungsprüfer",
      "InsuranceSelection": "Für welche Versicherung sind Sie tätig?",
      "LastnamePlaceholder": "Nachname",
      "Others": "Andere",
      "PasswordConfimPlaceholder": "Passwort bestätigen",
      "PasswordPlaceholder": "Passwort wählen",
      "PersonalEmailIsRequired": "Für Vertragsabschlüsse ist zwingend eine persönliche E-Mail-Adresse notwendig!",
      "RegisterButton": "Registrieren",
      "Registration": "Registrierung",
      "RegistrationInfo": "Neue Benutzer können sich hier registrieren.",
      "RegistrationInfoApprovalRequired": "Nach erfolgreicher Prüfung werden Sie freigeschaltet.",
      "RegistrationSucceeded": "<b>Wir haben Ihre Anfrage erhalten.</b> Sie erhalten eine E-Mail, sobald Ihr Account freigeschaltet wurde.",
      "SelfIdentification": "Bitte wählen Sie Ihre Funktion aus",
      "StreetPlaceholder": "Strasse",
      "Title": "Medicalculis Intranet Registrierung",
      "TitlePlaceholder": "Titel Dr.med. / Prof. Dr.",
      "ZSRNumberHint": "<b>Bitte persönliche ZSR erfassen, falls vorhanden.</b><br>Die ZSR-Nr können Sie <a href=\"{{zsrUrl}}\" target=\"_blank\"> hier suchen.</a>",
      "ZSRNumberPlaceholder": "Persönliche ZSR-Nummer"
    },
    "ResendConfirmEmail": {
      "Errors": {
        "NoEmailSetText": "Bei diesem Benutzer ist keine E-Mail hinterlegt.",
        "NoEmailSetTitle": "Keine E-Mail hinterlegt"
      },
      "ResendConfirmed": "Die Bestätigungsmail wurde erneut versendet. Bitte prüfen Sie ihren Posteingang und klicken Sie auf den Bestätigungslink.",
      "ResendInProgress": "Die Bestätigungsmail wird erneut versendet, bitte warten.",
      "Title": "E-Mail Bestätigungslink erneut versenden"
    }
  },
  "Admin": {
    "Emails": {
      "Errors": {
        "NoEmailsSelectedText": "Bitte wählen Sie mindestens ein Ereignislog aus.",
        "NoEmailsSelectedTitle": "Keine Ereignislogs ausgewählt."
      },
      "Header": "E-Mails",
      "ResetMultipleEmailErrors": "Fehlerstatus zurücksetzen",
      "ResetMultipleEmailErrorsConfirmationDialogText": "Bitte bestätigen Sie, dass Sie den Fehlerstatus der selektierten E-Mails zurücksetzen wollen. (Es werden nur E-Mails mit Fehlerstatus zurückgesetzt) ",
      "ResetMultipleEmailErrorsConfirmationDialogTitle": "Fehlerstatus zurücksetzen"
    },
    "EventLogs": {
      "EmailsDialogTitle": "E-Mails von EventLog \"{{id}}\"",
      "Errors": {
        "NoEventLogsSelectedText": "Bitte wählen Sie mindestens ein Ereignislog aus.",
        "NoEventLogsSelectedTitle": "Keine Ereignislogs ausgewählt."
      },
      "Header": "Ereignis Logs",
      "ReferenceId": "Referenz ID",
      "ReferenceType": "Referenz Typ",
      "ResendEmails": "E-Mails erneut versenden",
      "ResendEmailsConfirmationDialogText": "Bitte bestätigen Sie, dass für die selektierten Ereignislogs die E-Mails nachversendet werden sollen. (Die E-Mails werden erneut aus der Vorlage generiert und anschliessend versendet)",
      "ResendEmailsConfirmationDialogTitle": "E-Mails nachversenden",
      "ShowEmailsButtonToolTip": "E-Mails anzeigen",
      "Text": "Text",
      "Timestamp": "Datum",
      "Type": "Typ"
    },
    "Info": {
      "ApplicationLockoutEnabled": "Applikation sperren",
      "DisplayWarningMessage": "Warnungstext anzeigen",
      "Header": "Admin-Info",
      "InvoiceInfoDialogPage": "Invoice Info Dialog Seite",
      "LockoutText": "Text für Sperrung. (Wird auf der Loginseite angezeigt)",
      "SmsCredits": "SMS Credits",
      "SmsSentInLastQuarter": "Gesamte SMS verwendet im letzten Quartal",
      "WarningMessage": "Warnungstext"
    },
    "Rules": {
      "AddRule": "Regel hinzufügen",
      "Catalog": "Katalog",
      "Context": "Kontext",
      "DeleteRule": "Regel löschen",
      "DeleteRuleText": "Soll diese Regel wirklich gelöscht werden?",
      "EditRule": "Regel bearbeiten",
      "Errors": {
        "ContextRequired": "Kontext muss ausgefüllt werden.",
        "ExpressionRequired": "Regel muss ausgefüllt werden.",
        "MessageRequired": "Nachricht muss ausgefüllt werden.",
        "NameRequired": "Name muss ausgefüllt werden.",
        "OrderRequired": "Reihenfolge muss ausgefüllt werden."
      },
      "Expression": "Regel",
      "Header": "Regeln",
      "IsActive": "Aktiv",
      "Message": "Nachricht",
      "Order": "Reihenfolge",
      "ResultType": "Resultat Typ",
      "RuleResultTypes": {
        "Error": "Fehler",
        "Warning": "Warnung"
      },
      "Triggers": "Auslöser"
    }
  },
  "Anesthesia": {
    "Class": "Anästhesieklasse",
    "ClassLabel": "Anästhesieklasse {{class}}",
    "Date": "Datum",
    "Duration": "Eingriffsdauer",
    "DurationHours": "Stunden",
    "DurationMinutes": "Minuten",
    "EmergencySurcharge": "Notfallzuschlag 30% (000.2200.0)",
    "Errors": {
      "MinDuration": "Die Eingriffsdauer muss mindestens 30 Minuten betragen."
    },
    "FlatRateHint": "Hinweis: Falls vorhanden, muss die entsprechende Honorarpauschal-Position (9XX.XXX.5) verwendet werden.",
    "Preview": "Positionen"
  },
  "BankAccount": {
    "ValidQrIban": "Gültige QR-IBAN",
    "ValidRegularIban": "Gültige IBAN"
  },
  "Catalog": {
    "CatalogItemTypes": {
      "AdditionalAssistant": "Jeder weiterer Assistent",
      "FirstAssistant": "Erster Assistent",
      "FlatRateForAssistant": "Pauschalleistung für Assistenten",
      "FlatRateForMainServiceProvider": "Pauschalleistung",
      "FlatRateSurcharge": "Zuschlag für Pauschalleistung",
      "Surcharge": "Zuschlag",
      "TariffPosition": "Tarifposition",
      "Visit": "Visite",
      "VisitFlatRateSurcharge": "Zuschlag für Visite"
    },
    "EditCatalogItem": {
      "PreEditDialog": {
        "CreateNew": "Neuen Eintrag anlegen",
        "EditExisting": "Bestehenden bearbeiten",
        "Text": "Wollen Sie den bestehenden Eintrag bearbeiten oder basierend auf diesem Eintrag einen neuen Eintrag anlegen?",
        "Title": "Eintrag Bearbeiten oder Anlegen"
      },
      "PreEditDialogOnlyEdit": {
        "Text": "Basierend auf diesem Eintrag wurde bereits ein neuer Eintrag abgeleitet. Der Eintrag kann nur bearbeitet werden.",
        "Title": "Eintrag Bearbeiten"
      }
    },
    "EditCatalogView": {
      "AdditionalInfo": "Info Text",
      "CatalogViewOrder": "Reihenfolge der Ansicht",
      "ColumnPrefix": "Spalte",
      "ColumnWidth": "Breite",
      "DefaultSort": "Standard Sortierung",
      "Filter": "Filter",
      "HideColumn": "Spalte in Tabelle ausblenden",
      "IsActive": "Aktiv",
      "ShowColumn": "Spalte in Tabelle einblenden",
      "TableWidth": "Tabellenbreite"
    },
    "Errors": {
      "ColumnRequired": "Dieser Eintrag muss zwingend ausgefüllt sein.",
      "UserNotAuthorizedForCatalogViewText": "Sie sind nicht berechtigt für diese Katalog-Ansicht."
    },
    "Management": {
      "AddCatalogItem": "Position hinzufügen",
      "CatalogItemFilterDate": "Katalogeinträge auf Datum filtern",
      "DeleteCatalogItem": "Position löschen",
      "DeleteCatalogItemText": "Soll diese Position wirklich gelöscht werden?",
      "EditCatalogItem": "Position bearbeiten",
      "EditCatalogView": "Katalog Ansicht bearbeiten",
      "ExportComparisonBaseValidDate": "Basisdatum",
      "ExportComparisonCompareValidDate": "Vergleichsdatum",
      "ExportDialogText": "Bitte geben Sie das gewünschte Gültigkeitsdatum für den Export ein. Das Datum kann auch gelöscht werden, um alle Datensätze zu exportieren.",
      "ExportValidDate": "Gültigkeitsdatum",
      "HistoryTitle": "Historie von Eintrag \"{{uid}}\"",
      "Import": {
        "Added": "Hinzugefügt",
        "CurrentFile": "Aktuelle Datei",
        "DropExcelToAttach": "Excel-Datei hier ablegen oder ",
        "DropExcelToAttachLink": "durchsuchen",
        "ErrorCodes": {
          "HeaderRowNotFound": "Kopfzeile nicht gefunden",
          "InvalidHeaderStructure": "Ungültige Spaltenstruktur",
          "NoWorksheetFound": "Kein Arbeitsblatt in der Excel-Datei gefunden",
          "ProcessingFailed": "Verarbeitung fehlgeschlagen",
          "UnexpectedError": "Unerwarteter Fehler"
        },
        "ErrorsLabel": "Fehler",
        "ImportCompletedSuccessfully": "Import erfolgreich abgeschlossen",
        "ImportCompletedWithErrors": "Import mit Fehlern abgeschlossen",
        "ImportExcel": "Excel-Import",
        "ImportStart": "Import starten",
        "Imported": "Importiert",
        "Importing": "Importieren",
        "OverwriteExistingItems": "Bestehende Katalogeinträge direkt überschreiben (ohne Historie)",
        "RowsProcessed": "Katalogeinträge verarbeitet",
        "Skipped": "Übersprungen",
        "Status": {
          "Completed": "Import abgeschlossen",
          "Failed": "Import fehlgeschlagen",
          "Initializing": "Import wird initialisiert...",
          "Processing": "{{count}} Zeilen werden verarbeitet",
          "Saving": "Änderungen werden in der Datenbank gespeichert",
          "Starting": "Import wird gestartet...",
          "Unknown": "Unbekannter Status"
        },
        "TotalRows": "Gesamt Katalogeinträge",
        "Updated": "Aktualisiert"
      },
      "ShowHistory": "Historie anzeigen"
    }
  },
  "Contract": {
    "AddContract": "Vertrag hinzufügen (Entwurf)",
    "AddressHeader": "Adresse",
    "CashingFeeAppliedToOkp": "Gebühr auf OKP",
    "CashingFeeAppliedToOkpTooltip": "Wenn 'Nein' wird die Gebühr nur auf den VVG Anteil erhoben.",
    "CompensationType": {
      "Factor": "Faktor",
      "FixedPrice": "Fixpreis",
      "TaxPointValue": "Taxpunktwert"
    },
    "DefaultTerminationDateExpressionHeader": "Kündigungsdatum Regel",
    "DeleteContract": "Vertrag löschen",
    "DeleteContractText": "Soll dieser Vertrag wirklich gelöscht werden?",
    "EditContract": "Vertrag bearbeiten",
    "EditFinalContract": "Aktiven Vertrag bearbeiten",
    "EditFinalContractDialogText": "Dieser Vertrag wurde bereits freigegeben. Die Änderungen werden nicht auf bereits abgeschlossene Einzelverträge übernommen. Bitte erfassen Sie eine Begründung für die Änderung am aktiven Rahmenvertrag.",
    "EditFinalContractReasonLabel": "Begründung",
    "Errors": {
      "Factor": "Der Faktor muss ausgefüllt sein, mindestens 0 betragen und darf höchstens 4 Deziamlstellen haben.",
      "InsuranceRequiredForNonInvoiceOnlyContracts": "Eine Versicherung muss ausgewählt sein, wenn der Vertrag nicht den Typ 'Nur für Invoice' hat.",
      "InsuranceRequiredWhenFactorSet": "Eine Versicherung muss ausgewählt sein, wenn Faktor P1 oder P2 gesetzt ist.",
      "OkpFactorRequiredWithoutInsurance": "Der OKP-Faktor muss grösser als 0 sein, wenn keine Versicherung ausgewählt ist.",
      "SecondaryCatalogViewMustDifferFromCatalogViewId": "Bitte wählen Sie einen sekundären Katalog welcher sich vom Katalog unterscheidet.",
      "SecondaryCatalogViewWithoutCatalogView": "Wählen Sie zuerst einen Katalog.",
      "TertiaryCatalogViewMustDifferFromOtherCatalogViews": "Bitte wählen Sie einen tertiären Katalog welcher sich vom Katalog und sekundären Katalog unterscheidet.",
      "TertiaryCatalogViewWithoutSecondaryCatalogView": "Wählen Sie zuerst einen sekundären Katalog.",
      "TitleAlreadyExists": "Ein Vertrag mit diesem Titel existiert bereits.",
      "TitleRequired": "Titel muss ausgefüllt sein."
    },
    "ExcludeOkpFactorPositionSpecific": "OKP-Faktor positionsspezifisch ausschliessen",
    "ExcludeOkpFactorPositionSpecificTooltip": "Wenn aktiviert, wird der OKP-Faktor bei Positionen ausgeschlossen, die dafür vorgesehen sind. Die Berechnung berücksichtigt dann nur VVG- und Individualfaktor.",
    "ExtendContract": "Vertrag verlängern",
    "ExtendContractDialog": {
      "Text": "Der Rahmenvertrag und alle noch aktiven Einzelverträge werden auf das neue Datum verlängert.",
      "Title": "Vertrag verlängern",
      "ValidUntilLabel": "Neues Gültig bis Datum"
    },
    "FinalizeContractDraft": "Vertrag freigeben",
    "FinalizeContractDraftConfirmationText": "Wollen Sie den Vertrag freigeben?",
    "Header": "Rahmenverträge",
    "InstitutionFactorsHint": "Die Institution hat spezifische OKP-Faktoren hinterlegt.",
    "InstitutionGroupWarning": "Diese Klinik kann selbstständig von der Klinikgruppe '{{institutionGroupName}}' verwaltet werden. Sprechen Sie Änderungen am Vertrag ab.",
    "InvoiceReceivers": "Rechnungsempfänger",
    "InvoiceReceiversTooltip": "Sobald ein Rechnungsempfänger zugewiesen ist, wird die Auswahl beim Erstellen der Rechnung angeboten. Ohne Auswahl wird der Rechnungsempfänger der Institution erzwungen.",
    "InvoicingFeeRates": {
      "AddRate": "Gebühr hinzufügen",
      "CurrentRate": "{{percentage}} %",
      "CurrentRateWithScheduled": "{{percentage}} % → {{scheduledPercentage}} % ab {{scheduledValidFrom}}",
      "DeleteRate": "Löschen",
      "Errors": {
        "NotUnique": "Pro Datum 'Gültig von' darf nur eine Gebühr erfasst werden."
      },
      "Hint": "Für eine Rechnung gilt die Gebühr, welche zum 'Hospitalisierung Von' Datum der Rechnung gültig war. Bereits erstellte Rechnungen behalten immer ihre Gebühr.",
      "Percentage": "Gebühr (%)"
    },
    "IsDraft": {
      "Draft": "Entwurf",
      "Final": "Aktiv"
    },
    "IsForSpecialistsOnly": "Nur für Fachärzte",
    "IsForSpecialistsOnlyTooltip": "Wenn aktiviert kann der Vertrag nur von Fachärzten verwendet werden.",
    "NoInvoiceReceiverOption": "Kein elektronischer Rechnungsempfänger",
    "NoInvoiceReceiverOptionTooltip": "Nur wenn aktiviert, kann beim Erstellen der Rechnung 'Kein elektronischer Rechnungsempfänger' ausgewählt werden.",
    "OfferValidityManagedExternally": "Offerteneinstellungen werden in Contracto Insurance verwaltet.",
    "OfferValidityWeeksValue": "Offertengültigkeit: {{weeks}} Wochen.",
    "ParentContractHeader": "Übergeordneter Vertrag",
    "Pdf": {
      "Pdf02Title": "Zusatz 1",
      "Pdf02TitleLabel": "Zusatz 1 (optional)",
      "Pdf03Title": "Zusatz 2",
      "Pdf03TitleLabel": "Zusatz 2 (optional)",
      "PdfTitle": "Vertrag"
    },
    "SaveDraft": "Entwurf speichern",
    "SecondaryCatalogView": "Sekundärer Katalog",
    "SecondaryCatalogViewTooltip": "Wenn gesetzt steht der Katalog als zweiter Katalog bei der Rechnungsstellung zur Verfügung.",
    "SignatureHeader": "Signatur",
    "StartPhaseEndValue": "Startphase bis {{date}}.",
    "Status": {
      "Active": "Aktiv",
      "ContractWasValidUntil": "Vertrag war gültig bis {{validUntilDate}}.",
      "Denied": "Abgelehnt",
      "InProcessing": "In Bearbeitung",
      "OfferDeadline": "Offerte gültig bis {{offerDeadlineDate}}.",
      "Replaced": "Ersetzt",
      "Terminated": "Gekündigt",
      "TerminatedDate": "Wurde am {{terminatedDate}}{{terminatedBy}} gekündigt.",
      "UserConfirmationPending": "Bestätigung durch Benutzer offen",
      "UserConfirmationPendingInSentence": "Bestätigung durch Benutzer offen.",
      "UserDeclined": "Offerte abgelehnt"
    },
    "TerminationType": {
      "AutomaticallyTerminated": "Automatisch gekündigt",
      "AutomaticallyTerminatedInSentence": " automatisch",
      "TerminatedByInsurance": "Von Versicherung gekündigt",
      "TerminatedByInsuranceInSentence": " von der Versicherung",
      "TerminatedByUser": "Von Benutzer gekündigt",
      "TerminatedByUserInSentence": " vom Benutzer",
      "Title": "Kündigungsart"
    },
    "TertiaryCatalogView": "Tertiärer Katalog",
    "TertiaryCatalogViewTooltip": "Wenn gesetzt steht der Katalog als dritter Katalog bei der Rechnungsstellung zur Verfügung.",
    "Type": {
      "InvoiceOnly": "Nur für Invoice",
      "Standard": "Standard",
      "UserMustConfirm": "Benutzer Bestätigung"
    },
    "TypeLabel": "Typ",
    "ValidFromEmptyHint": "Für Einzelverträge wird das aktuelle Datum als Standard-Startdatum verwendet.",
    "ValidFromOpen": "Ohne Startdatum",
    "ValidUntilChangeWarning": "Achtung: Bei Änderung des \"Gültig bis\" Datums werden die Einzelverträge nicht automatisch angepasst. Verwenden Sie die Funktion \"Vertrag verlängern\" um auch die Einzelverträge zu aktualisieren.",
    "ValidUntilUnlimited": "Unbefristet",
    "WithdrawalPeriodHeader": "Widerrufsfrist"
  },
  "Dashboard": {
    "InfoText": "<h4>Beispiel Text</h4>"
  },
  "DataTable": {
    "AddRowTitle": "Datensatz hinzufügen",
    "DeleteRowText": "Soll dieser Datensatz wirklich gelöscht werden?",
    "DeleteRowTitle": "Datensatz löschen",
    "EditRowTitle": "Datensatz bearbeiten"
  },
  "Dialog": {
    "AcceptTermsDialog": {
      "AcceptTermsCheckboxText": "Ich akzeptiere die Nutzungsbedingungen"
    },
    "EditEmployeeContainerComponent": {
      "ZSRNumberHint": "Die ZSR-Nr können Sie <a href=\"{{zsrUrl}}\" target=\"_blank\"> hier suchen.</a>"
    },
    "EditInvoiceContainerComponent": {
      "CaseNumber": "Fallnummer",
      "CaseNumberPlaceholder": "z.B. 1549876127",
      "PIDOptional": "PID (Fakultativ)"
    },
    "EditInvoiceInsuranceContainerComponent": {
      "FactorsCannotBeChanged": "Faktoren können bei diesem Vertragstyp nicht geändert werden.",
      "FactorsDifferently": "Unterschiedliche Faktoren in selektierten Verträgen.",
      "FieldWillBeChanged": "Dieses Feld wird für alle markierten Verträge angepasst.",
      "FieldWillNotBeChanged": "Dieses Feld wird nicht angepasst.",
      "NoBaseFactor": "Faktor nicht vorhanden im Basisvertrag."
    },
    "EditInvoiceSessionContainerComponent": {
      "Errors": {
        "ManualValueRequired": "Bitte einen Wert für die Leistung {{positionNumbers}} eingeben.",
        "SessionDateRequired": "Sitzungsdatum muss ausgefüllt werden."
      },
      "MostUsedPositions": "Häufig benutzt",
      "Performances": "Leistungen",
      "RemoveServiceProvider": "{{ serviceProviderDisplay }} als Leistungserbringer entfernen",
      "SelectedPerformances": "Ausgewählte Leistungen",
      "SelectedSurcharges": "Ausgewählte Zuschläge",
      "SessionDate": "Sitzungsdatum",
      "SetMainItem": "Als Hauptleistung setzen",
      "SetServiceProvider": "Abweichenden Leistungserbringer setzen",
      "ShowAllPositions": "Alle Positionen",
      "Suggestions": "Passende Leistungen",
      "Surcharges": "Zuschläge"
    },
    "EditPositionServiceProvider": {
      "ServiceProvidersInSession": "Bereits verwendete Leistungserbringer"
    },
    "FileUploadDialog": {
      "Errors": {
        "RequestTooLargeText": "Die ausgewählte(n) Datei(en) überschreiten die Limite für Datei Uploads. Falls Sie mehrere Dateien hochladen können Sie versuchen die Dateien einzeln hochzuladen.",
        "RequestTooLargeTitle": "Dateilimite erreicht"
      },
      "Files": "Dateien",
      "OrDropHere": "Oder per Drag & Drop hier ablegen.",
      "SaveSecure": "Dateien in sicheren Speicher hochladen. (Kann nur mit Login herunterladen werden)",
      "SelectFiles": "Dateien auswählen",
      "ShouldOverwriteFiles": "Sollen die Dateien überschreiben werden?",
      "Title": "Dateien hochladen",
      "Upload": "Hochladen"
    },
    "InfoLinkDialog": {
      "Errors": {
        "LinkRequired": "Link muss ausgefüllt werden.",
        "RequestTooLargeText": "Die ausgewählte Datei überschreitet die Limite für Datei Uploads.",
        "RequestTooLargeTitle": "Dateilimite erreicht"
      },
      "File": "Datei",
      "OrDropHere": "Oder per Drag & Drop hier ablegen.",
      "SelectFile": "Datei auswählen",
      "Title": "Info Link",
      "Upload": "Info Link hinzufügen"
    },
    "ServiceTypeConfigDialogComponent": {
      "ServiceProvider": "Leistungserbringer (abweichend von Rechnungssteller)",
      "ServiceProviderType": "Arztkategorie",
      "ServiceProviderTypeRequired": "Bitte wählen Sie eine Kategorie",
      "ServiceType": "Art",
      "Title": "Leistungsarten wählen"
    },
    "SmsVerificationDialog": {
      "Title": "SMS Bestätigung"
    }
  },
  "Email": {
    "Columns": {
      "CC": "CC",
      "CreateDate": "Erstellt",
      "ErrorCounter": "Fehleranzahl",
      "From": "Von",
      "Priority": "Priorität",
      "SendDate": "Gesendet",
      "Status": "Status",
      "Subject": "Betreff",
      "To": "An"
    },
    "Status": {
      "Error": "Fehler beim Versand",
      "Pending": "In Warteschlange",
      "Sending": "Wird gesendet",
      "Sent": "Gesendet"
    }
  },
  "Employee": {
    "Errors": {
      "GlnRequired": "Bitte die GLN eingeben.",
      "OnlyNaturalPersons": "Es können nur natürliche Personen als Mitarbeiter angelegt werden.",
      "SaveAnyways": "Soll trotzdem gespeichert werden?"
    },
    "Management": {
      "AddAssistant": "Assistent hinzufügen",
      "AddEmployee": "Arzt hinzufügen",
      "EditEmployee": "Arzt bearbeiten",
      "FilterContractToDo": "Nur Einträge ohne Verträge oder mit offener Bestätigung anzeigen."
    },
    "Search": {
      "Hint": "Bitte wählen Sie einen Arzt (natürliche Person) aus <a href=\"{{refDataGlnUrl}}\" target=\"_blank\">Refdata</a> aus, indem Sie hier nach GLN oder Nachnamen suchen:",
      "NoResults": "Keine Ergebnisse gefunden",
      "Results": "Suchergebnisse",
      "SearchBy": "Suchen nach",
      "SearchTermGln": "GLN",
      "SearchTermLastName": "Nachname",
      "Title": "Arzt auswählen"
    }
  },
  "ErrorHandler": {
    "BackendOfflineErrorText": "Der Server ist aktuell nicht erreichbar. Bitte versuchen Sie es später nochmals oder melden Sie sich bei ihrem Administrator.",
    "BackendOfflineErrorTitle": "Server nicht erreichbar",
    "BadRequestTitle": "Fehler",
    "ForbiddenText": "Sie sind nicht berechtigt für dieses Modul.",
    "ForbiddenTitle": "Nicht berechtigt",
    "InternalServerErrorDevTitle": "Fehler im API",
    "InternalServerErrorProdText": "Es ist ein unerwarteter Fehler aufgetreten. Falls das Problem weiterhin besteht melden Sie sich bitte bei ihrem Administrator.",
    "InternalServerErrorProdTitle": "Unerwarteter Fehler",
    "ReloadApplication": "Applikation neu laden",
    "SessionExpiredText": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "SessionExpiredTitle": "Sitzung abgelaufen",
    "TooManyRequestsErrorText": "Es wurden zu viele Anfragen in kurzer Zeit gesendet. Bitte versuchen Sie es in {{retryAfter}} Sekunden nochmals.",
    "TooManyRequestsErrorTitle": "Zu viele Anfragen",
    "UserLockoutText": "Der Zugriff auf die Applikation ist gesperrt oder wurde noch nicht freigeschaltet.",
    "UserLockoutTitle": "Benutzer gesperrt",
    "WarningTitle": "Warnung"
  },
  "Favorites": {
    "AddToFavorites": "Zu Favoriten hinzufügen",
    "All": "Alle Favoriten",
    "DefaultFolder": "Favoriten",
    "DialogTitle": "Als Favorit speichern",
    "Folder": "Ordner",
    "NewFolder": "Neuer Ordner",
    "RemoveFromFavorites": "Aus Favoriten entfernen",
    "Title": "Favoriten"
  },
  "Global": {
    "AccountType": "Account Typ",
    "ActiveFrom": "Aktiv von",
    "ActiveUntil": "Aktiv bis",
    "All": "Alle",
    "ApplicationUpdateAvailable": "Es ist eine neue Version der Webseite verfügbar. Bitte klicken Sie auf OK, um die Seite neu zu laden.",
    "ApplicationUpdateAvailableTitle": "Neue Version verfügbar",
    "ApprovalReason": {
      "DelegateUserType": "Automatisiert aufgrund Benutzerklasse Stellvertretung",
      "ExternalInstitutionData": "Automatisiert via Insitutionsdatenabgleich"
    },
    "ApprovedBy": "Freigeschaltet durch",
    "ApprovedDate": "Freigeschaltet am",
    "Assistant": "Assistent",
    "BESR": "QR Referenz",
    "BackToLoginButton": "Zurück zum Login",
    "BankAccount": "Bankverbindung",
    "BankAccountIban": "IBAN",
    "BankAccountIbanOrQrIban": "IBAN / QR-IBAN",
    "BankAccountIbanTooltip": "Bei der Rechnungsstellung wird für gewisse Rechnungsempfänger eine QR-IBAN benötigt.",
    "BankAccountQrIban": "QR-IBAN",
    "Cancel": "Abbrechen",
    "Canton": "Kanton",
    "CaseNumber": "Fallnummer",
    "Catalog": "Katalog",
    "CatalogItems": "Katalog Positionen",
    "CatalogView": "Katalog Ansicht",
    "CatalogViews": "Katalog Ansichten",
    "Choose": "Wählen",
    "City": "Ort",
    "ClearFilter": "Filter löschen",
    "Close": "Schliessen",
    "CloseDialog": "Dialog schliessen",
    "CompensationType": "Vergütungstyp",
    "Contract": "Vertrag",
    "ContractContactInformation": "Kontaktinformationen",
    "ContractContactInformationHeader": "Kontakt",
    "ContractContactInformationTooltip": "Kontaktinformationen anzeigen",
    "ContractContent": "Vertrags-Inhalt",
    "ContractDoctors": "Vertragsärzte",
    "Contracts": "Verträge",
    "ControllingForInvoiceReceiver": "Invoice Controlling für Rechnungsempfänger",
    "ControllingForInvoiceReceiverInfo": "Benutzer kann Rechnungen der ausgewählten Rechnungsempfänger einsehen, bestätigen und ablehnen.",
    "Copy": "Kopieren",
    "Count": "Anzahl",
    "CreatedBy": "Erfasst von",
    "CsvExport": "CSV-Export",
    "Date": "Datum",
    "DateOfBirth": "Geburtsdatum",
    "DeclineReason": "Ablehnungsgrund",
    "Decrease": "Verringern",
    "Delegations": "Stellvertretung",
    "Delete": "Löschen",
    "Description": "Beschreibung",
    "Details": "Details",
    "DontShowAgain": "Nicht mehr anzeigen",
    "Draft": "Entwurf",
    "EMail": "E-Mail",
    "Edit": "Bearbeiten",
    "EmailConfirmed": "E-Mail bestätigt",
    "EmployedFrom": "Angestellt von",
    "EmployedUntil": "Angestellt bis",
    "Employee": "Arztliste",
    "EmployeeGroups": "Ärztelisten",
    "Enlarge": "Vergrössern",
    "Errors": {
      "BankAccountIbanInvalid": "Bitte geben Sie eine gültige IBAN ein.",
      "DateIsRequired": "Bitte füllen Sie das Datum aus.",
      "FieldIsRequired": "Bitte füllen Sie dieses Feld aus.",
      "GlnInvalid": "Die GLN ist ungültig.",
      "GlnLength": "Die GLN muss aus 13 Ziffern bestehen.",
      "GlnPatternInvalid": "Ungültiges Format der GLN.",
      "GlnRequired": "Die GLN muss ausgefüllt sein.",
      "GlnServiceUnavailable": "Die GLN konnte nicht geprüft werden, da der Prüfdienst aktuell nicht erreichbar ist.",
      "InvalidDate": "Ungültiges Datum.",
      "LoadFailed": "Daten konnten nicht geladen werden.",
      "MaxLength": "Bitte verwenden Sie maximal {{limit}} Zeichen",
      "MobilePhoneNumberPattern": "Nummer im Format +41XXXXXXXXX eingeben.",
      "MobilePhoneNumberRequired": "Mobile-Nr. wird benötigt.",
      "PostalCodeInvalid": "Bitte geben Sie eine numerische Postleitzahl ein.",
      "PostalCodeRequired": "Bitte geben Sie eine Postleitzahl ein.",
      "QrReferencePrefixInvalid": "Der Wert muss numerisch sein",
      "SaveFailed": "Speichern fehlgeschlagen.",
      "TextIsRequired": "Bitte füllen Sie den Text aus.",
      "TextTooShort": "Bitte geben Sie mehr Text ein.",
      "ValidFromMustBeBeforeValidUntil": "Datum muss vor dem gültig bis Datum sein.",
      "ValidFromRequired": "Bitte gültig von eintragen.",
      "ValidUntilMustBeAfterValidFrom": "Datum muss nach dem gültig von Datum sein.",
      "ZsrNumberInvalid": "Ungültiges Format der ZSR-Nummer."
    },
    "Evaluation": "Bewertung",
    "ExcelExport": "Excel-Export",
    "ExcelExportComparison": "Excel-Export Vergleich",
    "Factor": "Faktor",
    "FactorP1": "Privat",
    "FactorP2": "Halbprivat",
    "FirstName": "Vorname",
    "For": "für",
    "Frequency": "Häufigkeit",
    "FunctionTitle": "Facharzttitel",
    "Gender": "Geschlecht",
    "GenderFemale": "weiblich",
    "GenderMale": "männlich",
    "Gln": "GLN",
    "GlnHint": "Die GLN können Sie <a href=\"{{refDataGlnUrl}}\" target=\"_blank\"> hier suchen.</a>",
    "Groups": "Gruppen",
    "GuestAssistant": "Gastassistent",
    "GuestDoctor": "Gastarzt",
    "GuestDoctors": "Gastärzte",
    "HospitalizationFrom": "Hospitalisierung von",
    "HospitalizationUntil": "Hospitalisierung bis",
    "Id": "Id",
    "Identifier": "Kennung",
    "Increase": "Erhöhen",
    "IndividualFactor": "Individueller Faktor",
    "IndividualFactorShort": "Ind. Faktor",
    "Info": "Info",
    "InfoLinks": "Info Links",
    "Institution": "Institution",
    "InstitutionClinic": "Institution/Klinik",
    "InstitutionPractice": "Praxis- / Institutsname",
    "Institutions": "Institutionen",
    "Insurance": "Versicherung",
    "InsuranceType": "Versicherungsart",
    "InsuranceTypeGeneral": "Allgemein",
    "InsuranceTypePrivate": "Privat",
    "InsuranceTypeSemiPrivate": "Halbprivat",
    "Insurances": "Versicherungen",
    "Invoice": "Rechnung",
    "InvoiceDate": "Rechnungsdatum",
    "InvoiceReceiver": "Rechnungsempfänger",
    "InvoiceReceiverSettingsButton": "Einstellungen für {{invoiceReceiverTitle}}",
    "InvoiceReceiverSettingsHint": "Einstellungen für Rechnungsempfänger für diesen Benutzer. Nur relevant, wenn der Benutzer diesen Empfänger für Rechnungen verwendet.",
    "InvoiceReceivers": "Rechnungsempfänger",
    "Invoices": "Rechnungen",
    "InvoicingFee": "Gebühr",
    "InvoicingZsrNumber": "ZSR-Nr. zur Abrechnung",
    "InvoicingZsrNumberHint": "<b>Bitte abweichende ZSR (Praxis-ZSR) erfassen, falls Sie nicht mit Ihrer persönlichen ZSR abrechnen.<br>K-Nummern (6 Ziffern+Buchstabe) sind nicht erlaubt.</b><br>Die ZSR-Nr können Sie <a href=\"{{zsrUrl}}\" target=\"_blank\"> hier suchen.</a>",
    "KeyboardHints": {
      "ArrowKeysSelect": "↑↓ wählen",
      "EnterApply": "Enter übernehmen",
      "EscClose": "Esc schliessen"
    },
    "Kind": "Art",
    "Language": "Sprache",
    "LastChange": "Letzte Änderung",
    "LastLogin": "Letztes Login",
    "LastName": "Nachname",
    "MainPerformance": "Hauptleistung",
    "MainServiceProvider": "Hauptleistungserbringer",
    "Memo": "Memo",
    "MobilePhoneNumber": "Mobile-Nr.",
    "Name": "Name",
    "No": "Nein",
    "NoResults": "Keine Ergebnisse gefunden",
    "Nr": "Nr",
    "Number": "Nummer",
    "OKPFactor": "OKP-Faktor",
    "ObjectPermissions": "Objektberechtigungen",
    "Ok": "Ok",
    "OverallFactorP1": "Gesamt privat",
    "OverallFactorP2": "Gesamt halbprivat",
    "PID": "PID",
    "Password": "Passwort",
    "PatientID": "Patienten-ID",
    "PdfExport": "PDF-Export",
    "PhoneNumber": "Telefonnummer",
    "PleaseSelect": "Bitte wählen",
    "PositionValue": "Positions-Wert",
    "PostalCode": "PLZ",
    "Refresh": "Aktualisieren",
    "Remove": "Entfernen",
    "ResultCount": {
      "Plural": "Ergebnisse",
      "Singular": "Ergebnis"
    },
    "Retry": "Erneut versuchen",
    "Roles": "Rollen",
    "Save": "Speichern",
    "SaveAnyway": "Trotzdem speichern",
    "Search": "Suche",
    "Select": "Wählen",
    "SelectAll": "Alle auswählen",
    "SelectDateRange": "Datumsbereich auswählen",
    "SelectedCount": "{{count}} ausgewählt",
    "SentAt": "Verschickt am",
    "ServiceProvider": "Leistungserbringer",
    "ServiceText": "Leistungstext",
    "Sessions": "Sitzungen",
    "ShowDetails": "Details anzeigen",
    "ShowLess": "weniger anzeigen",
    "ShowMore": "alles anzeigen",
    "Shrink": "Verkleinern",
    "Specialist": "Facharzt",
    "SpecialistHint": "Mit 'Facharzt' markierte Benutzer können Rahmenverträge verwenden die nur für Fachärzte bestimmt sind. Nur relevant für PS25. Muss nur bei Problemen manuell gesetzt werden, sollte sonst aus Institutionsdaten automatisch abgeleitet werden.",
    "State": "Status",
    "Street": "Strasse",
    "SubTotalTaxPoints": "Subtotal Taxpunkte",
    "Surcharge": "Zuschlag",
    "SurchargeFactor": "Faktor Zuschlag",
    "Title": "Titel",
    "Total": "Total",
    "TotalTaxPoints": "Total Taxpunkte",
    "TreatmentDate": "Behandlungsdatum",
    "Type": "Typ",
    "TypeHereToSearch": "Hier tippen um zu suchen",
    "Unknown": "Unbekannt",
    "UsedAs": "Verwendet als",
    "User": "Benutzer",
    "UserContracts": "Benutzer Verträge",
    "UserInfo": "User-Info",
    "UserName": "Benutzername",
    "UserType": "Benutzerklasse",
    "VVGFactorP1": "VVG privat",
    "VVGFactorP1WithCompensationType": "VVG {{compensationType}} privat",
    "VVGFactorP2": "VVG halbprivat",
    "VVGFactorP2WithCompensationType": "VVG {{compensationType}} halbprivat",
    "ValidFrom": "Gültig von",
    "ValidFromOnActivation": "ab Aktivierung",
    "ValidPermanent": "Unbefristet",
    "ValidUntil": "Gültig bis",
    "Valuation": "Bewertung",
    "Value": "Wert",
    "Visit": "Visite",
    "WithoutGroup": "Ohne Gruppe",
    "WithoutInstitution": "Ohne Institution",
    "Yes": "Ja",
    "ZsrNumber": "ZSR-Nr."
  },
  "Home": {
    "BrowserModal": {
      "ButtonText": "Webseite dennoch benutzen",
      "Text": "Der '{{browserName}}' Browser wird nicht mehr offiziell unterstützt.<br><br>Mit diesem Browser können Sie nicht alle Funktionen dieser Webseite nutzen.",
      "Title": "Browser nicht unterstützt"
    },
    "ForgotPasswordButton": "Neues Passwort anfordern",
    "ForgotPasswordInfo": "Wenn Sie sich bereits registriert und Ihr Passwort vergessen haben, dann können Sie hier ein neues Passwort anfordern.",
    "Info": "<ul><li>Als neuer User müssen Sie sich als erstes registrieren (Neuanmeldung).</li><li style=\"margin-bottom:10px;\">Ihre Registrierung wird geprüft und Sie erhalten eine E-Mail sobald Sie die Seite nutzen können.</li><li>Ihr Benutzername ist Ihre E-Mail-Adresse mit der Sie sich registriert haben.</li><li>Nach dem Login gelangen Sie auf die Intranetstartseite von Medicalculis </li><li>Von dort können Sie zu den Leistungsbewertungen und den Verträgen navigieren</li></ul>",
    "Login": {
      "EmailPassword": "Login mit E-Mail & Passwort",
      "HIN": "Login mit HIN"
    },
    "RegisterButton": "Neuanmeldung",
    "Title": "Intranet Medicalculis"
  },
  "IndividualCompensation": {
    "AddIndividualCompensation": "Faktor hinzufügen",
    "DeleteIndividualCompensation": "Löschen",
    "Errors": {
      "NotUnique": "Der individuelle Faktor muss eindeutig sein."
    },
    "Header": "Faktoren",
    "IsDefault": "Standardauswahl",
    "Reference": "LERB-Gruppe"
  },
  "Info": {
    "AddInfoLink": "Info Link hinzufügen",
    "DeleteInfoLink": "Info Link löschen",
    "DeleteInfoLinkText": "Soll dieser Info Link wirklich gelöscht werden?",
    "EditInfoLink": "Info Link bearbeiten",
    "EditInfoLinks": "Info Links bearbeiten",
    "GeneralInfoLinks": "Allgemein",
    "Header": "Info",
    "InstitutionSpecificInfoLinks": "Institutionsspezifisch",
    "InstitutionsForPhysician": "Sichtbarkeit einschränken auf Belegärzte folgender Institutionen:",
    "InstitutionsWithoutGroup": "Ohne Klinikgruppe",
    "InsurancesForUserClass": "Sichtbarkeit einschränken auf Benutzer folgender Versicherungen:",
    "IsPublic": "Für alle Benutzer sichtbar",
    "LinkAction": {
      "DownloadFile": "Datei herunterladen",
      "OpenInNewTab": "Nicht geschützten Link in neuem Tab öffnen",
      "OpenPdf": "Geschütztes PDF in neuem Tab öffnen",
      "OpenPdfDialog": "PDF in Dialog öffnen"
    },
    "LinkActionHeader": "Link-Aktion",
    "LinkHeader": "Link",
    "Order": "Reihenfolge",
    "UploadFiles": "Dateien hochladen",
    "UserGroupPermissionHint": "Die Sichtbarkeit der Links kann zusätzlich über die Gruppen eingestellt werden.",
    "Visibility": "Sichtbarkeit"
  },
  "Institution": {
    "AddInstitution": "Institution hinzufügen",
    "Cantons": {
      "Ag": "Aargau",
      "Ai": "Appenzell Innerrhoden",
      "Ar": "Appenzell Ausserrhoden",
      "Be": "Bern",
      "Bl": "Basel-Landschaft",
      "Bs": "Basel-Stadt",
      "Fr": "Freiburg",
      "Ge": "Genf",
      "Gl": "Glarus",
      "Gr": "Graubünden",
      "Ju": "Jura",
      "Lu": "Luzern",
      "Ne": "Neuenburg",
      "Nw": "Nidwalden",
      "Ow": "Obwalden",
      "Sg": "St. Gallen",
      "Sh": "Schaffhausen",
      "So": "Solothurn",
      "Sz": "Schwyz",
      "Tg": "Thurgau",
      "Ti": "Tessin",
      "Ur": "Uri",
      "Vd": "Waadt",
      "Vs": "Wallis",
      "Zg": "Zug",
      "Zh": "Zürich"
    },
    "CaseNumberRequired": "Fallnummer ist Pflichtfeld",
    "DeleteInstitution": "Institution löschen",
    "DeleteInstitutionText": "Soll diese Institution wirklich gelöscht werden?",
    "EditInstitution": "Institution bearbeiten",
    "Errors": {
      "CantonFormat": "Kanton muss ausgefüllt sein (für Forum Datenaustausch)",
      "TitleRequired": "Titel muss ausgefüllt sein.",
      "ZsrFormat": "ZSR muss aus einem Buchstaben gefolgt von sechs Zahlen bestehen."
    },
    "Factors": {
      "AddFactor": "Faktor hinzufügen",
      "ClearValidUntil": "Gültig bis löschen",
      "Columns": {
        "ExternalCode": "Extern",
        "MedRegCode": "MedReg",
        "OkpFactor": "OKP",
        "Qualification": "Fachgruppe"
      },
      "ConfirmDelete": "Diesen Faktor wirklich löschen?",
      "DeleteFactor": "Faktor löschen",
      "Description": "Diese Faktoren werden vertragsunabhängig angewandt wenn der Leistungserbringer den entsprechenden validierten Fachtitel besitzt.",
      "EditFactor": "Faktor bearbeiten",
      "EditValidUntil": "Gültig bis bearbeiten – {{qualification}}",
      "Errors": {
        "OkpFactorBoundaries": "Der OKP-Faktor muss zwischen {{min}} und {{max}} liegen.",
        "OverlappingFactor": "Der Faktor überschneidet sich mit einem bestehenden Faktor.",
        "ValidUntilMustBeAfterValidFrom": "Gültig bis muss nach Gültig von liegen."
      },
      "FactorInUse": "Dieser Faktor wurde bereits verwendet (zuletzt am {{date}}) und kann nicht mehr bearbeitet werden.",
      "FactorInUseValidUntilOnly": "Zuletzt verwendet am {{date}} – nur noch «Gültig bis» kann verändert werden.",
      "FilterByQualification": "Nach Fachgruppe filtern",
      "ManageButton": "Institutionsfaktoren verwalten",
      "NewFactor": "Neuer Faktor",
      "ResultCount": {
        "All": {
          "Plural": "Faktoren",
          "Singular": "Faktor"
        },
        "CurrentlyValid": {
          "Plural": "heute gültige Faktoren",
          "Singular": "heute gültiger Faktor"
        }
      },
      "SelectQualification": "Fachgruppe auswählen",
      "ShowAll": "Alle anzeigen",
      "ShowOnlyCurrentlyValid": "Nur aktuell gültige anzeigen",
      "Title": "Institutionsfaktoren"
    },
    "GlnEmptyHint": "Für Institutionen sollte eine GLN erfasst werden. Lassen Sie das Feld nur in begründeten Ausnahmefällen leer.",
    "Header": "Institutionen",
    "InstitutionGroup": "Klinikgruppe",
    "InstitutionGroupAdmin": "Admin für Klinikgruppe",
    "InstitutionGroupDetails": "Gruppendetails",
    "InstitutionGroupIdentityProvider": "Identity Provider",
    "InstitutionGroupSubDomain": "Subdomain",
    "InstitutionGroupTooltip": "Legt fest, zu welcher Klinikgruppe die Institution gehört. Klinikgruppenadmins dieser Gruppe können deren Benutzer verwalten. Zudem erscheint die Institution bei der Registrierung über die passende Subdomain.",
    "InstitutionGroupUserDomain": "User Domain",
    "InvoiceReceiverCopyOnly": "(nur Kopie)",
    "InvoiceReceiverTooltip": "Versand an den Empfänger wird erzwungen falls nicht anders am Vertrag konfiguriert"
  },
  "Insurance": {
    "AddInsurance": "Versicherung hinzufügen",
    "DeleteInsurance": "Versicherung löschen",
    "DeleteInsuranceText": "Soll diese Versicherung wirklich gelöscht werden?",
    "EditInsurance": "Versicherung bearbeiten",
    "Errors": {
      "TitleRequired": "Titel muss ausgefüllt sein."
    },
    "GlnEmptyHint": "Ohne GLN kann diese Versicherung nicht für Rechnungen verwendet werden.",
    "Header": "Versicherungen",
    "ParentInsurance": "Vertreten durch",
    "PendingUserContracts": {
      "AcceptContractsDialogText": "Bitte bestätigen Sie, dass Sie die markierten Verträge annehmen/offerieren möchten.",
      "AcceptContractsDialogTitle": "Verträge annehmen/offerieren",
      "AcceptSelected": "Markierte annehmen/offerieren",
      "CannotEditFactorsHint": "Sie haben Verträge mit verschiedenen Basisverträgen oder verschiedenen Vertragstypen markiert, daher können die Faktoren nicht bearbeitet werden.<br>Faktoren können nur bei Verträgen geändert werden die vom Benutzer bestätigt werden müssen.",
      "DeclineContractsDialogText": "Bitte bestätigen Sie, dass Sie die markierten Verträge ablehnen möchten.",
      "DeclineContractsDialogTitle": "Verträge ablehnen",
      "DeclineSelected": "Markierte ablehnen",
      "EditAndAcceptSelected": "Markierte bearbeiten und annehmen/offerieren",
      "EditUserContract": "Vertrag bearbeiten",
      "Header": "Ausstehende Verträge"
    },
    "PhysicianSearchHirslanden": "Ärztesuche Hirslanden",
    "UserContracts": {
      "ContractChangesExcelReport": "Excel-Export Vertragsänderungen",
      "Header": "Verträge",
      "SelectTerminationDateDialog": {
        "AdditionalTextLabel": "Begründung (Wird per E-Mail verschickt)",
        "TerminationDateLabel": "Kündigen auf (Datum)",
        "Title": "Verträge kündigen",
        "VariousTerminationDatesHint": "Es haben nicht alle Verträge das gleiche Standard-Kündigungsdatum. Wenn Sie hier ein Datum eintragen wird das ausgewählte Kündigungsdatum bei allen Verträgen verwendet."
      },
      "TerminateContractsDialogText": "Bitte bestätigen Sie, dass Sie die markierten Verträge kündigen möchten.",
      "TerminateContractsDialogTitle": "Verträge kündigen",
      "TerminateSelected": "Markierte kündigen"
    }
  },
  "Invoice": {
    "AcceptTermsDialog": {
      "Text": "Bitte akzeptieren Sie die Nutzungsbedingungen, um Invoice verwenden zu können.",
      "Title": "Nutzungsbedingungen für Invoice"
    },
    "Controlling": {
      "ApproveInvoice": "Rechnung als abgeholt markieren",
      "ApproveInvoiceDialogText": "Bitte bestätigen Sie, dass Sie diese Rechnung als abgeholt markieren möchten.",
      "DeclineInvoice": "Rechnung ablehnen",
      "DeclineInvoiceDialogText": "Bitte geben Sie eine Begründung ein, warum diese Rechnung abgelehnt wird.<br>Der Text wird per Mail an den Benutzer weiterleitet, daher bitte keine Patientendaten eintragen.",
      "ShowInvoice": "Rechnung anzeigen"
    },
    "DeclinedDate": "Abgelehnt am",
    "Delegations": {
      "AddDelegation": "Stellvertretung hinzufügen",
      "DelegateNotRegistered": "Account nicht bei Contracto registriert oder noch nicht mit Hirslanden verknüpft.",
      "Description": "Folgende Benutzer können in Ihrem Namen Rechnungen erstellen:",
      "Dialog": {
        "AllInstitutionsTooltip": "Ihre Stellvertretung kann automatisch auf denjenigen Institutionen Rechnungen erstellen, mit welchen Sie als Belegarzt Verträge haben",
        "ButtonCancel": "Abbrechen",
        "ButtonDelete": "Stv. beenden",
        "ButtonInvite": "Einladen",
        "ButtonUpdate": "Aktualisieren",
        "ConfirmationCreate": "Mit <strong>Einladen</strong> bestätigen Sie, dass die angegebene Person unter Ihrem Namen Rechnungen erstellen kann",
        "ConfirmationUpdate": "Mit <strong>Aktualisieren</strong> ändern Sie die Berechtigungen der Stellvertretung",
        "DescriptionCreate": "Laden Sie eine Person ein, welche als Stellvertretung für Sie Rechnungen erstellen kann",
        "DescriptionEdit": "Bearbeiten Sie die Stellvertretung und deren Berechtigungen",
        "EmailLabel": "E-Mail Adresse der Stellvertretung",
        "EmailNotFound": "Die E-Mail Adresse konnte nicht gefunden werden. Die Person muss bereits als Stellvertretung registriert sein, um hinzugefügt werden zu können.",
        "EmailRequired": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "EmailValidated": "E-Mail Adresse erfolgreich validiert",
        "EmailValidationError": "Fehler bei der Validierung",
        "ErrorCreate": "Fehler beim Erstellen der Stellvertretung",
        "ErrorDelete": "Fehler beim Beenden der Stellvertretung",
        "ErrorUpdate": "Fehler beim Aktualisieren der Stellvertretung",
        "InstitutionQuestion": "Für welche Institutionen kann die Stellvertretung Rechnungen erstellen?",
        "InstitutionRestrictedTooltip": "Diese Institution wird extern verwaltet.",
        "InvalidUserTypeError": "Der Benutzer hat nicht die erforderliche Benutzerklasse 'Stellvertretung'.",
        "InvalidUserTypeTooltip": "Eine Aktualisierung oder Beendigung der Stellvertretung ist nicht möglich.",
        "ModeAllInstitutions": "Alle Institutionen",
        "ModeSpecificInstitutions": "Nur bestimmte Institutionen",
        "NoInternalInstitutions": "Wählen Sie mindestens eine Institution aus",
        "RestrictedInstitutionsTitle": "Hirslanden Institutionen",
        "RestrictedInstitutionsWarning": "Für Institutionen der Hirslanden werden die Stellvertretungen im <a href=\"https://fiori.hirslanden.ch/\" target=\"_blank\" rel=\"noopener noreferrer\">Hirslanden Ärztecockpit</a> verwaltet.",
        "SuccessCreated": "Stellvertretung erfolgreich erstellt",
        "SuccessDeleted": "Stellvertretung erfolgreich beendet",
        "SuccessUpdated": "Stellvertretung erfolgreich aktualisiert"
      },
      "DoctorCockpitLink": "Hirslanden Ärztecockpit",
      "EditDelegation": "Stellvertretung bearbeiten",
      "ExternalDelegationDeleteTooltip": "Diese Stellvertretung wird extern verwaltet und kann nur im Ärztecockpit beendet werden.",
      "IdpLoginRequired": "Loggen Sie sich mit Ihrem Hirslanden Account ein, um extern verwaltete Stellvertretungen zu sehen.",
      "NoDelegations": "Keine Stellvertretungen vorhanden",
      "NoInternalInstitutionsTooltip": "Sie haben keine intern verwalteten Institutionen. Stellvertretungen für extern verwaltete Institutionen können im Ärztecockpit verwaltet werden.",
      "Table": {
        "Action": "Aktion",
        "Edit": "Bearbeiten",
        "Email": "E-Mail Adresse",
        "Institutions": "Freigegebene Institutionen"
      },
      "Tooltip": {
        "Extern": "extern",
        "NoInstitutions": "Keine Institutionen",
        "Title": "Freigegebene Institutionen"
      }
    },
    "LastSentDate": "Gesendet am",
    "ServiceProvider": {
      "GroupTranslations": {
        "Anesthesiologists": "Anästhesisten",
        "Angestellte Ärzte": "Angestellte Ärzte",
        "Anästhesisten": "Anästhesisten",
        "Gastassistenten": "Gastassistenten"
      },
      "Info": "In der Liste \"Assistenzen mit Verträgen\" erscheinen nur die Ärzte, welche am Eintrittstag des Patienten für die Klinik, in der er behandelt wurde mit der gewählten Versicherung einen gültigen Vertrag haben.<br><br>Alle anderen Ärzte müssen als Gastassistenten einmal manuell erfasst werden (und vorab einmal an die Partnerversicherungen gem. Merkblätter in der Rubrik  Info) gemeldet werden.<ul><li>Bei Ärzten mit einem gültigen VVG-Vertrag am Eintrittstag des Patienten für die Klinik - gilt für den Assistenten sein eigener Faktor.</li><li>Bei Gastassistenten ohne gültigen VVG-Vertrag am Eintrittstag des Patienten für die Klinik - wird der Faktor des Fallführers übernommen.</li></ul><br>Wenn der Arzt einen gültigen Vertrag mit der Versicherung hat, darf er nicht parallel als Gastarzt benutzt werden.<br>Bitte beachten Sie, dass bei rückwirkenden Anschlüssen (bis 4 Monate nach Eintrittstag möglich) oder verzögerter Rechnungsstellung die Rechnung erste korrekt gestellt werden kann, wenn der Vertragsstatus aller Assistenzen klar ist.",
      "ManagementLinkText": "Link zum Erfassen von {{Name}}",
      "NoServiceProvidersAvailable": "Keine Leistungserbringer zur Auswahl vorhanden."
    },
    "ServiceProviders": {
      "Header": "Invoice Ärzte"
    },
    "Status": {
      "Approved": "Abgeholt",
      "Declined": "Abgelehnt",
      "Draft": "Entwurf",
      "Sent": "Gesendet"
    }
  },
  "Languages": {
    "de-CH": "Deutsch",
    "fr-CH": "Französisch",
    "it-CH": "Italienisch"
  },
  "Nav": {
    "Dropdowns": {
      "Admin": "Admin",
      "Invoice": "InvoicePro"
    },
    "Links": {
      "AcceptInvoiceTerms": "Nutzungsbedingungen akzeptieren",
      "AdminInfo": "Admin Info",
      "Catalogs": "Kataloge",
      "ChangePassword": "Passwort ändern",
      "ConfigureOtp": "Zwei-Faktor Authentisierung einrichten",
      "Contracts": "Rahmenverträge",
      "Dashboard": "Dashboard",
      "Delegation": "Stellvertretung",
      "EditProfile": "Profil editieren",
      "Emails": "E-Mails",
      "Employee": "Ärztelisten",
      "EventLogs": "Ereignis Logs",
      "Info": "Info",
      "Institutions": "Institutionen",
      "InsuranceContracts": "Verträge",
      "Insurances": "Versicherungen",
      "Invoice": "InvoicePro",
      "InvoiceControlling": "Controlling",
      "InvoiceDelegations": "Stellvertretungen",
      "InvoiceManual": "InvoicePro Anleitung",
      "InvoiceServiceProviders": "Invoice Ärzte",
      "InvoiceTerms": "Nutzungsbedingungen",
      "Invoices": "Rechnungen",
      "LinkHin": "HIN-Login verknüpfen",
      "LinkIdp": "{{idp}}-Login verknüpfen",
      "Logout": "Logout",
      "Patients": "Patienten",
      "PendingInsuranceContracts": "Ausstehende Verträge",
      "Rules": "Regeln",
      "Statistics": "Statistiken",
      "UserContracts": "Meine Verträge",
      "UserGroups": "Gruppen",
      "UserManagement": "Benutzer",
      "UserManagementPending": "Anfragen"
    },
    "Menus": {
      "UserMenu": "Benutzermenü"
    },
    "Title": "Medicalculis",
    "Welcome": "Willkommen"
  },
  "ObjectPermissions": {
    "CanCreate": "Erstellen",
    "CanDelete": "Löschen",
    "CanExport": "Exportieren",
    "CanRead": "Lesen",
    "CanUpdate": "Aktualisieren",
    "Object": "Objekt Typ",
    "ObjectId": "Objekt",
    "ObjectTypeDescriptions": {
      "User": "Alle Benutzer",
      "UserContract": "Verträge der Versicherung"
    },
    "ObjectTypes": {
      "CatalogItem": "Katalog Positionen",
      "CatalogView": "Katalog Ansicht",
      "Employee": "Ärztelisten",
      "InfoLinks": "Info Links",
      "UserContract": "Verträge"
    }
  },
  "Providers": {
    "Paginator": {
      "FirstPage_Label": "Erste Seite",
      "ItemsPerPage_Label": "Datensätze pro Seite",
      "LastPage_Label": "Letzte Seite",
      "NextPage_Label": "Nächste Seite",
      "Of_Label": "von",
      "PreviousPage_Label": "Vorherige Seite"
    }
  },
  "Roles": {
    "Description": {
      "Admin": "User kann Adminrollen vergeben.",
      "CloseContractsEmail": "Benutzer erhält eine E-Mail, wenn ein neuer Vertragsantrag gestellt wurde. (Benutzer muss auch der Versicherung zugeordnet sein)",
      "CloseContractsUser": "Vertragsanträge können vom Benutzer eingereicht werden.",
      "Delegate": "Benutzer können im Auftrag von anderen Rechnungen erstellen",
      "EditContracts": "Verträge können angenommen oder abgelehnt werden.",
      "FileUpload": "Benutzer kann Dateien hochladen.",
      "Invoice": "Rechnungen des Benutzers können eingesehen und bearbeitet werden.",
      "InvoiceControlling": "Benutzer kann Rechnungen der Institutionen einsehen, bestätigen und ablehnen.",
      "InvoiceControllingEmail": "Benutzer erhält eine E-Mail, wenn Rechnungen ans Controlling gesendet werden.",
      "RoleManagement": "Usern können Rollen zugeteilt werden.",
      "UserManagement": "User können verwaltet werden.",
      "UserRegisterEmail": "Benutzer erhält eine E-Mail, wenn sich neue Benutzer registrieren.",
      "ViewContracts": "Verträge können gesehen werden."
    }
  },
  "Statistics": {
    "Filter": {
      "DateFrom": "Zeitraum von",
      "DateTo": "bis",
      "ExcelExport": "Excel exportieren",
      "FeesReport": "Gebühren Report exportieren",
      "Institutions": "Institutionen",
      "Insurances": "Versicherungen",
      "LoadStatistics": "Statistiken laden",
      "Option": {
        "AllInstitutions": "Alle Institutionen",
        "AllInsurances": "Alle Versicherungen"
      },
      "Placeholder": {
        "SelectInstitutions": "Alle Institutionen",
        "SelectInsurances": "Alle Versicherungen"
      }
    },
    "InvoiceStatusPerUser": {
      "Table": {
        "Header": {
          "Approved": "Akzeptiert",
          "Declined": "Abgelehnt",
          "Draft": "Entwurf",
          "Name": "Name",
          "Sent": "Gesendet"
        },
        "NoData": "Keine Daten vorhanden",
        "Totals": "Gesamt"
      },
      "Title": "Rechnungen pro Benutzer nach Bearbeitungsstatus"
    },
    "JoinedDoctorsByInsuranceAndInstitution": {
      "Doctors": {
        "Table": {
          "Header": {
            "ContractMonth": "Medicalculis-Vetrag unterschrieben im Monat",
            "ContractYear": "Medicalculis-Vetrag unterschrieben im Jahr",
            "Count": "Anzahl",
            "Institution": "Institution",
            "Insurance": "Versicherung"
          },
          "NoData": "Keine Daten vorhanden"
        },
        "Title": "Beigetretene Ärzte mit Medicalculis-Vertrag nach Institution und Beitrittsdatum"
      },
      "Invoices": {
        "Table": {
          "Header": {
            "AverageAmount": "Durchschnittlicher Rechnungsbetrag",
            "Count": "Anzahl",
            "Institution": "Institution",
            "Insurance": "Versicherung",
            "SentMonth": "Versendet im Monat",
            "SentYear": "Versendet im Jahr",
            "TotalAmount": "Summe Rechnungsbetrag"
          },
          "NoData": "Keine Daten vorhanden"
        },
        "Title": "Gesendete Rechnungen nach Institution und Versicherung (ohne abgelehnte)",
        "Totals": "Gesamt"
      }
    },
    "Table": {
      "CollapsedMessage": "Klicken Sie hier, um die Tabelle anzuzeigen"
    },
    "Tabs": {
      "ContractsOverview": "Vertragsübersicht",
      "DoctorsAndInvoices": "Ärzte und Rechnungen"
    },
    "Tiles": {
      "ApprovedCount": "Akzeptiert",
      "AverageAmount": "Durchschnittlicher Betrag",
      "DeclinedCount": "Abgelehnt",
      "DoctorDistributionByInstitution": {
        "Table": {
          "Header": {
            "Count": "Anzahl",
            "Institution": "Institution",
            "Percentage": "Prozent"
          },
          "NoData": "Keine Daten vorhanden"
        },
        "Title": "Verteilung der Ärzte nach Institution"
      },
      "DraftCount": "Entwürfe",
      "InvoicesSubtitle": "Gesamtanzahl der versendeten Rechnungen",
      "SentCount": "Gesendet",
      "TotalAmountSubtitle": "Gesamtsumme aller versendeten Rechnungen",
      "TotalDoctors": "Anzahl Ärzte",
      "TotalDoctorsWithContract": "Ärzte mit Vertrag",
      "TotalDoctorsWithContractSubtitle": "Gesamtanzahl der Ärzte mit aktivem Vertrag",
      "TotalInvoices": "Rechnungen",
      "TotalSum": "Rechnungsbetrag"
    },
    "Title": "Statistiken"
  },
  "SupportWidget": {
    "ConfirmationMessage": "Ihre Nachricht wurde erfolgreich gesendet.",
    "ContactFormTitle": "Kontaktaufnahme",
    "OpenHelp": "Hilfe öffnen",
    "Submit": "Absenden",
    "WelcomeMessage": "Willkommen im Support Center"
  },
  "Url": {
    "InvoiceManualPdf": "/pdf/Anleitung_InvoicePro.pdf"
  },
  "User": {
    "Contracts": {
      "AcceptOrConfirmSelected": "Markierte beantragen/bestätigen",
      "AcceptSelectedDialogText": "Ich bestätige, dass ich für die folgenden Verträge eine Offertanfrage beantragen, respektive einen Vertrag abschliessen will:</br></br>",
      "AcceptSelectedDialogTitle": "Bestätigung für Offertanfrage/Vertragsabschlüsse",
      "ConfirmSelectedDialogContractText": "{{Title}}:<br><div style=\"margin-left: 25px;\">VVG Faktor: Privat = {{VvgP1}} Halbprivat = {{VvgP2}}<br>Gesamt: Privat = {{FactorP1}} Halbprivat = {{FactorP2}}<br>Individueller Faktor: {{IndividualFactor}}<br>{{Validity}}</div>",
      "ConfirmSelectedDialogContractTextWithoutCompensation": "{{Title}}: {{Validity}}",
      "ConfirmSelectedDialogContractValidity": "Gültig von {{ValidFrom}} bis {{ValidUntil}}",
      "ConfirmSelectedDialogContractValidityFromConfirmation": "Gültig ab Bestätigung bis {{ValidUntil}}",
      "ConfirmSelectedDialogText": "Ich bestätigte, dass ich die folgenden Verträge inklusive aller Zusätze rechtsverbindlich abschliessen will. Zudem akzeptiere ich hiermit die Allgemeinen Vertragsbestimmungen, welche die Einzelheiten des Vertrages regeln.</br></br>",
      "ConfirmSelectedDialogTitle": "Bestätigung für Vertragsabschlüsse",
      "ContractNameHeader": "Name",
      "ContractStatusHeader": "Status",
      "ContractValidFromHeader": "Gültig von",
      "ContractValidUntilHeader": "Gültig bis",
      "DeclineSelectedDialogText": "Sie beabsichtigen die folgenden Offerten abzulehnen.<br>Setzen Sie ich mit der Versicherung per Mail in Verbindung.<br>Durch die Ablehnung wird die Versicherung über die Ablehnung per Mail informiert.<br>Nach der Ablehnung können Sie hier direkt wieder eine Offertanfrage stellen.</br></br>",
      "DeclineSelectedDialogTitle": "Vertragsofferte(n) ablehnen",
      "Errors": {
        "NoContractsSelectedText": "Es wurden keine Verträge ausgewählt.",
        "NoContractsSelectedTitle": "Keine Verträge ausgewählt",
        "SelectActiveOrIsUserConfirmationPendingContractsOnlyText": "Bitte nur aktive Verträge oder Verträge mit ausstehender Bestätigung auswählen.",
        "SelectActiveOrIsUserConfirmationPendingContractsOnlyTitle": "Vertragsselektion ungültig",
        "SelectInactiveContractsOnlyText": "Bitte nur noch nicht aktive Verträge auswählen.",
        "SelectInactiveContractsOnlyTitle": "Vertragsselektion ungültig",
        "SelectPendingOrUserConfirmationPendingContractsOnlyText": "Bitte nur Vertragsanträge oder Vertragsbestätigungen gleichzeitig auswählen.",
        "SelectPendingOrUserConfirmationPendingContractsOnlyTitle": "Vertragsselektion ungültig",
        "SmsVerificationFailedDialogText": "Falscher SMS Code!",
        "SmsVerificationFailedDialogTitle": "SMS Code falsch.",
        "UserContractNegativeListBlockedContactInsuranceText": "Sie sind nicht berechtigt, folgende Verträge zu beantragen / bestätigen:{{contracts}}Für weitere Auskünfte wenden Sie sich bitte direkt an die Versicherung.",
        "UserContractNegativeListBlockedContactMailText": "Sie sind nicht berechtigt, folgende Verträge zu beantragen / bestätigen:{{contracts}}Für weitere Auskünfte wenden Sie sich bitte direkt an <a href=\"mailto:{{email}}\">{{email}}</a>",
        "UserContractNegativeListBlockedTitle": "Antrag / Bestätigung nicht möglich",
        "UserMustEnterMobileDialogText": "Für den Abschluss von Verträgen muss eine Mobiltelefonnummer im Benutzerprofil hinterlegt sein. Bitte tragen Sie diese in ihren Benutzereinstellungen ein.",
        "UserMustEnterMobileDialogTitle": "Mobiltelefonnummer muss hinterlegt sein"
      },
      "FilterUserContracts": "Inaktive Verträge anzeigen",
      "Header": "Verträge",
      "InfoText": "<p><b>Hier sehen Sie Ihre Verträge und können Verträge online abschliessen:</b></p><ul><li>Die hier angenommenen Verträge sind rechtlich verbindlich.</li><li>Unter \"Vertrags-Inhalt\" können Sie die Vertragstexte als PDF ansehen.</li><li>Wählen Sie die gewünschten Verträge aus und bestätigen Sie mit dem entsprechenden Button.</li></ul>",
      "SelectAll": "Alle auswählen",
      "TerminateOrDeclineSelected": "Markierte kündigen/ablehnen",
      "TerminateSelectedDialogContractAdvice": "<b>Wichtig</b>: Standortspezifische Vertragszusätze werden nicht gekündigt, sofern ein weiterer Vertrag zwischen dem entsprechenden Standort und einer Versicherung abgeschlossen ist.",
      "TerminateSelectedDialogContractOutsideWithdrawalText": "Kündigung (heute) auf den {{TerminationDate}} gemäss Kündigungsfrist.",
      "TerminateSelectedDialogContractText": "{{Title}}:<br><div style=\"margin-left: 25px;\">{{Text}}</div>",
      "TerminateSelectedDialogContractVariousTerminationDatesHint": "Es haben nicht alle Verträge das gleiche Standard Kündigungsdatum. Wenn Sie hier ein Datum eintragen wird das ausgewählte Kündigungsdatum bei allen Verträgen verwendet.",
      "TerminateSelectedDialogContractWithinWithdrawalText": "Kündigung innerhalb der Rücktrittsfrist wird sofort gekündigt.<br>Rücktrittsfrist beträgt {{WithdrawalPeriod}} Tage.",
      "TerminateSelectedDialogText": "Ich bestätige, dass ich die folgenden Verträge rechtsverbindlich kündigen will:</br></br>",
      "TerminateSelectedDialogTitle": "Bestätigung der Vertragskündigung",
      "UserMustEnterMobile": "<p>⚠️ Um Verträge abschliessen zu können, muss eine Mobiltelefonnummer im Benutzerprofil hinterlegt sein. Zum Abschliessen eines Antrages wird ein Code per SMS versendet welcher zur Bestätigung eingegeben werden muss. Bitte tragen Sie diese in ihren Benutzereinstellungen ein.<br><a class=\"color-white\" href=\"#\" routerlink=\"user/profile\">Link zum Benutzerprofil</a></p>",
      "ValidFromOnConfirmation": "ab Bestätigung"
    },
    "Delegation": {
      "Account": "Account",
      "ContractoCoreAccount": "Contracto Core",
      "CurrentDelegator": "Stellvertretung für",
      "DelegationInformation": "Sie können im Auftrag folgender Benutzer Rechnungen stellen:",
      "DelegatorNeedsToRegister": "⚠️ Kein Belegarzt verknüpft",
      "Description": "Sie können im Auftrag folgender Benutzer Rechnungen erstellen:",
      "Header": "Stellvertretung",
      "NoDelegations": "Sie haben keine Stellvertretungen.",
      "SourceInternal": "Intern",
      "Table": {
        "Action": "Aktion",
        "ConfirmEndMessage": "Möchten Sie die Stellvertretung für {{name}} wirklich beenden? Sie können danach keine Rechnungen mehr im Auftrag dieses Benutzers erstellen.",
        "ConfirmEndTitle": "Stellvertretung beenden",
        "Email": "E-Mail-Adresse",
        "EndDelegation": "Stv. beenden",
        "EndDelegationExternalTooltip": "Diese Stellvertretung wird extern verwaltet und kann hier nicht beendet werden.",
        "ExternalBadge": "ext. verwaltet",
        "Institutions": "Freigegebene Institutionen",
        "LinkageMissing": "Verknüpfung fehlt",
        "LinkageMissingTooltip": "Der Belegarzt hat sich nicht mit einem Account verknüpft. Dies ist notwendig um Rechnungen zu erstellen.",
        "Name": "Vor- und Nachname",
        "Tooltip": {
          "Extern": "extern",
          "NoInstitutions": "Keine Institutionen",
          "Title": "Freigegebene Institutionen"
        }
      },
      "UserInfos": {
        "GrantedTitle": "Vergebene Stellvertretungen",
        "NoDelegations": "Dieser Benutzer hat keine Stellvertretungen.",
        "ReceivedTitle": "Erhaltene Stellvertretungen",
        "SourceContracto": "In Contracto",
        "SourceDoctorCockpit": "Via Hirslanden Ärztecockpit"
      },
      "YourAccount": "Ihr Account: "
    },
    "Errors": {
      "EmployedFromAfterEmployedUntil": "Datum muss vor dem angestellt bis Datum sein.",
      "EmployedUntilAfterEmployedFrom": "Datum muss nach dem angestellt von Datum sein."
    },
    "Groups": {
      "AddGroup": "Gruppe hinzufügen",
      "AddObjectPermission": "Objektrecht hinzufügen",
      "AdminGroup": "Admin Gruppe",
      "DeleteObjectPermission": "Löschen",
      "EditGroup": "Gruppe bearbeiten",
      "Errors": {
        "NameRequired": "Name muss ausgefüllt werden.",
        "ObjectPermissionNotUnique": "Eintrag nicht eindeutig."
      },
      "GroupType": "Gruppentyp",
      "Header": "Benutzergruppen",
      "InvoiceGroup": "Invoice Gruppe",
      "InvoiceGuestAssistant": "Invoice Gastassistent",
      "Types": {
        "EmployeePerInstitution": "Arztliste pro Institution",
        "EmployeePerUser": "Arztliste pro User",
        "Standard": "Standard"
      }
    },
    "Insurance": {
      "CanApproveUserContracts": "Kann Verträge offerieren / ablehnen / kündigen",
      "ContractManager": "Vertragsmanager",
      "Function": "Funktion",
      "FunctionHint": "Ihre Funktion wird von healthinal verwaltet. Bitte wenden Sie sich an den Support, falls Sie weitere Berechtigungen benötigen.",
      "InsuranceRequired": "Bitte wählen Sie eine Versicherung aus.",
      "Reviewer": "Leistungsprüfer"
    },
    "Invoice": {
      "AddAnesthesiaSession": "Anästhesiezeit erfassen",
      "AddAssistant": "Assistent hinzufügen",
      "AddEditVisits": "Visiten hinzufügen/bearbeiten",
      "AddInvoiceSession": "Sitzung hinzufügen",
      "CloneInvoice": "Rechnung kopieren",
      "CopyBesrToClipboard": "Referenznummer in die Zwischenablage kopieren",
      "DeleteInvoiceSession": "Sitzung löschen",
      "DeleteInvoiceSessionDialogText": "Soll diese Sitzung wirklich gelöscht werden?",
      "DeleteServiceProvider": "Positionen dieses Leistungserbringers löschen",
      "DeleteServiceProviderDialogText": "Soll dieser Leistungserbringer wirklich aus der Sitzung gelöscht werden?",
      "DownloadInvoiceXml": "Rechnung als XML (Forum Datenaustausch) herunterladen",
      "EditAnesthesiaSession": "Anästhesiezeit bearbeiten",
      "EditAssistant": "Assistent bearbeiten",
      "EditInvoiceSession": "Zuschläge bearbeiten",
      "EditInvoiceSurcharges": "Zuschläge bearbeiten",
      "EditPositions": "Tarifpositionen bearbeiten",
      "EditVisits": "Visiten bearbeiten",
      "InvoiceApprovedChildInvoiceInfoText": "Es wurde bereits eine Kopie dieser Rechnung angelegt:",
      "InvoiceApprovedInfoText": "Diese Rechnung wurde akzeptiert und kann nicht mehr bearbeitet werden.",
      "InvoiceApprovedNoChildInvoiceInfoText": "Sie können über folgenden Link eine Kopie der Rechnung anlegen:",
      "InvoiceDeclinedChildInvoiceInfoText": "Es wurde bereits eine Kopie dieser Rechnung angelegt:",
      "InvoiceDeclinedInfoText": "Diese Rechnung wurde abgelehnt mit folgender Begründung:",
      "InvoiceDeclinedNoChildInvoiceInfoText": "Bitte legen Sie über folgenden Link eine Kopie der Rechnung an, um diese nochmals versenden zu können:",
      "NoPositionForAssistantInfoText": "Für diese Position ist keine Assistenz verrechenbar.",
      "NoPositionForServiceProviderInfoText": "Keine Position für diesen Leistungserbringer gefunden.",
      "ParentInvoiceInfoText": "Diese Rechnung wurde von folgender Rechnung abgeleitet:",
      "QrReferenceRequired": "QR Referenz erforderlich",
      "QrReferenceRequiredError": "Für den gewählten Rechnungsempfänger wird eine QR Referenz benötigt. Bitte erfassen Sie die QR Referenz über den Bearbeiten-Button der Rechnung, bevor Sie diese versenden.",
      "SendInvoice": "Rechnung versenden",
      "SendInvoiceDialogText": "Bitte bestätigen Sie, dass Sie diese Rechnung verschicken möchten. Anschliessend sind keine Änderungen mehr möglich.",
      "SendInvoiceDialogWithInvoiceReceiverText": "Diese Rechnung wird elektronisch an <strong>{{ receiverName }}</strong> versandt. Bitte versenden Sie die Rechnung nicht zusätzlich auf anderem Weg.",
      "ShowInvoicePdf": "Rechnung anzeigen"
    },
    "InvoiceVisits": {
      "ChangeServiceProvider": "Visiten für anderen Leistungserbringer erfassen",
      "SurchargeDisabledTooltip": "Ein Visitenzuschlag kann nur zusammen mit einer Visite am selben Tag ausgewählt werden",
      "Title": "Visiten hinzufügen"
    },
    "Invoices": {
      "AddInvoice": "Rechnung anlegen",
      "AddInvoiceForPatient": "für Patient:",
      "AdditionalConfirmation": "Ich bestätige, dass ich einen gültigen Vertrag mit {{ invoiceReceiver }} habe",
      "AssignmentAnd": "und",
      "AssignmentFrom": "ab",
      "AssignmentUntil": "bis",
      "BackToSsoLogin": "Mit {{ sso }} Account einloggen und Fall direkt auswählen",
      "CaseInsurance": "Versicherung im gewählten Fall",
      "CaseReset": "Rückgängig machen",
      "CaseSearchLabel": "Daten aus Fall übernehmen",
      "CaseSearchPlaceholder": "Vorname Nachname 01.01.1990",
      "CaseSearchResultCount": {
        "Plural": "{{ count }} Fälle gefunden",
        "Singular": "1 Fall gefunden"
      },
      "CaseSearchSearching": "Fälle werden gesucht …",
      "CaseSet": "Daten aus Fall {{ caseNumber }} übernommen. Überprüfen und ergänzen Sie die Informationen, falls nötig.",
      "CaseTreatmentCategories": {
        "General": "Allgemein",
        "Private": "Privat",
        "SemiPrivate": "Halbprivat"
      },
      "DeleteInvoice": "Rechnung löschen",
      "DeleteInvoiceText": "Soll diese Rechnung wirklich gelöscht werden?",
      "EditInvoice": "Rechnung bearbeiten",
      "EditPatient": "Patient bearbeiten",
      "EditPatientMarker": "(Bearbeitet)",
      "Errors": {
        "AdditionalPatientDataRequired": "Bitte vervollständigen Sie die nötigen Angaben zum Patienten.",
        "BankAccountIbanRequired": "Die IBAN muss ausgefüllt sein.",
        "BesrInvalid": "Die eingegebenen QR Referenz ist ungültig.",
        "CaseDataDifference": "Abweichende Falldaten ('{{caseData}}')",
        "CaseNumberInvalid": "Bitte geben Sie eine maximal 10 stellige Zahl ein.",
        "CaseNumberRequired": "Bitte geben Sie eine Fallnummer ein.",
        "ContractRequired": "Bitte wählen Sie einen Vertrag",
        "HospitalizationFromAfterHospitalizationUntil": "Datum muss vor dem Hospitalisierung bis Datum sein.",
        "HospitalizationFromRequired": "Bitte geben Sie das Hospitalisierung von Datum ein.",
        "HospitalizationUntilBeforeHospitalizationFrom": "Datum muss nach dem Hospitalisierung von Datum sein.",
        "HospitalizationUntilRequired": "Bitte geben Sie das Hospitalisierung bis Datum ein.",
        "InsuranceRequired": "Bitte wählen Sie die Versicherung",
        "InsuranceTypeRequired": "Bitte wählen Sie eine Versicherungsart",
        "MinLengthThree": "Bitte mindestens drei Zeichen verwenden",
        "NoActiveContract": "Kein aktiver Vertrag zum Datum {{ date }}",
        "PatientRequired": "Bitte wählen oder erstellen Sie den Patienten",
        "ZsrNumberRequired": "Eine ZSR wird für die Rechnungsstellung benötigt"
      },
      "ForPatient": "von Patient",
      "GenerateBesr": "Automatisch generieren",
      "GenerateBesrDisclaimer": "Wir empfehlen, diese Referenznummer im externen Buchhaltungssystem zu erstellen, damit Zahlungen dort korrekt nachvollzogen werden können. Ist dies nicht notwendig oder nicht möglich, kann die Referenz hier generiert werden. Für Verarbeitungsfehler oder Konsequenzen im Zusammenhang mit der Nachvollziehbarkeit von Zahlungen im eingesetzten externen Buchhaltungssystem bei der automatischen Generierung der QR-Referenz kann keine Haftung übernommen werden.",
      "Header": "Rechnungen",
      "Hints": {
        "BesrRequiredForSending": "Der ausgewählte Rechnungsempfänger erfordert eine QR Referenz. Diese muss vor dem Versenden der Rechnung erfasst werden.",
        "GenerateBesr": "Durch das Anlegen der Rechnung wird die Referenznummer automatisch generiert. Diese ist anschliessend im PDF und unter 'Rechnung bearbeiten' ersichtlich.",
        "SessionPositionOutOfDateRange": "Eine oder mehrere ausgewählte Positionen liegen ausserhalb des Rechnungszeitraums (Hospitalisierung von/bis). Bitte passen Sie den Zeitraum an oder entfernen Sie die betroffenen Positionen.",
        "SessionPositionSourceIsDraft": "Diese Position stammt aus einer Rechnung, die sich noch im Entwurfsstatus befindet",
        "SessionPositionsDerivable": "Für Anästhesisten: Verfügbare Positionen aus bestehender Operateurrechnung übernehmen",
        "SessionPositionsDerivableInfo": "Für die eingetragene Fallnummer und den gewählten Vertrag existiert bereits eine Operateurrechnung. Wählen Sie die Positionen aus, die übernommen werden sollen."
      },
      "InvalidQrIban": "Die eingegebene IBAN ist keine gültige QR-IBAN. Für den Versand an den gewählten Rechnungsempfänger muss zwingend eine gültige QR-IBAN hinterlegt werden.",
      "InvoiceReceiverSettings": {
        "Errors": {
          "SettingPattern": "Ungültiges Format",
          "SettingRequired": "Einstellung wird benötigt"
        },
        "Fields": {
          "cdm": {
            "accountNumber": "Ärztekasse-Kontonummer"
          },
          "medidata": {
            "clientId": "MediData client id",
            "gln": "(Fiktive) GLN"
          },
          "zak": {
            "contractId": "Zahnärztekasse Contract ID"
          }
        },
        "Hints": {
          "cdm": "Geben Sie hier Ihre Ärztekasse-Kontonummer ein. Andernfalls wird Ihre Abrechnungs- oder persönliche ZSR verwendet.",
          "zak": "Geben Sie hier die Contract ID ein, die Sie von der Zahnärztekasse beim Onboarding erhalten haben."
        },
        "MediData": {
          "Instruction1": "Bitte beantragen Sie Ihre Anbindung <a href='https://www.medidata.ch/md/online/public/onboarding/forms/' target='_blank'>hier</a>.<br />Bitte wählen Sie <b>Contracto (Medicalculis InvoicePro)</b> als <b>Softwareanbieter</b> und geben <b>die folgende GLN an</b>:",
          "Instruction2": "Die Freischaltung erfolgt im Normalfall innert 24-48 Stunden.<br />Wir werden Sie informieren, sobald Ihr Onboarding abgeschlossen ist.",
          "Intro": "Sie benötigen eine neue, kostenpflichtige MediData Anbindung.",
          "RequestNow": "Jetzt anfragen"
        },
        "SettingsMissing": "Für diesen Empfänger sind zusätzliche Einstellungen erforderlich",
        "Title": "Einstellungen",
        "Zak": {
          "Contact": "Bitte wenden Sie sich für das Onboarding an Ihren Kundenberater der Zahnärztekasse.",
          "Instruction": "Die von der Zahnärztekasse erhaltene Contract ID tragen Sie anschliessend über <b>Einstellungen</b> ein.",
          "Intro": "Für den Rechnungsversand an die Zahnärztekasse benötigen Sie eine Contract ID. Das Onboarding führt die Zahnärztekasse gemeinsam mit Ihnen durch."
        }
      },
      "InvoiceReceiverStatus": {
        "InvoiceReceiverLink": "Bei {{ invoiceReceiverTitle }} öffnen",
        "InvoiceReceiverReference": "Referenz",
        "InvoiceReceiverStatusChangedDate": "Zuletzt geändert",
        "InvoiceReceiverStatusDetails": "Details",
        "Label": "Empfängerstatus",
        "Status": {
          "MediData.Accepted": "Angenommen",
          "MediData.Pending": "Abklärung nötig (Details-Spalte beachten)",
          "MediData.Rejected": "Abgelehnt",
          "Zak.Accepted": "Angenommen",
          "Zak.Pending": "Abklärung nötig (Details-Spalte beachten)",
          "Zak.Rejected": "Abgelehnt"
        }
      },
      "InvoiceReceiverTitles": {
        "Caisse des Médecins": "Ärztekasse"
      },
      "InvoiceReceivers": "Rechnungsempfänger",
      "LogInWithSso": "Mit {{ sso }} Account einloggen",
      "LogInWithSsoNudge": "Neu: Bitte loggen Sie sich mit Ihrem {{ sso }} Account ein, um direkt einen Fall auszuwählen",
      "ManualDataEntryHint": "Sie finden den Fall nicht?",
      "ManualDataEntryLink": "Daten manuell erfassen",
      "NewPatient": "Neuer Patient",
      "NewPatientMarker": "(Neu)",
      "NoCasesFound": {
        "EarliestCaseStart": "Für diese Klinik sind Falldaten seit dem {{ earliestCaseStart }} vorhanden - ältere Daten sind nicht verfügbar",
        "NoCasesAvailable": "Es sind keine Fälle im System vorhanden",
        "NoUserAssignment": "Gemäss unseren Partnerdaten haben Sie aktuell keinen Zugriff",
        "Reasons": "Mögliche Gründe:",
        "RetentionHint": "Falldaten sind {{ retentionInMonths }} Monate verfügbar - ältere Fälle werden somit nicht gefunden",
        "SkillIssue": "Ihre Eingabe ist ungültig - korrigieren Sie diese",
        "Text": "Es wurden keine Fälle gefunden",
        "UserAssignments": "Gemäss unseren Partnerdaten haben Sie Zugriff auf Fälle:"
      },
      "NoCasesFoundReasons": "Mögliche Gründe:",
      "NoInvoiceReceiver": "Kein elektronischer Rechnungsempfänger",
      "Patient": "Patient",
      "PatientDiffersFromSelectedPatient": "Der vorausgewählte Patient ({{ patientDisplay }}) stimmt nicht genau mit den Falldaten überein und wurde daher ersetzt.",
      "ProfileDataMissingInfoText": "Um eine Rechnung erstellen zu können, müssen Angaben in Ihrem Benutzerprofil ergänzt werden. Bitte aktualisieren Sie die fehlenden oder ungültigen Felder.",
      "SaveAndCreate": "Speichern & Rechnung anlegen",
      "SendAnyway": "Trotzdem versenden",
      "SetCase": "Übernehmen",
      "TreatmentReason": {
        "Accident": "Unfall",
        "Disease": "Krankheit",
        "Label": "Behandlungsgrund",
        "Maternity": "Mutterschaft",
        "Prevention": "Vorsorge"
      },
      "UserProfileDataMissing": "Profilinformationen unvollständig"
    },
    "Logins": {
      "LoginDate": "Login Datum"
    },
    "Management": {
      "ApproveUserButtonText": "Freigeben",
      "ApproveUserText": "Soll dieser Benutzer wirklich freigegeben werden? Ihre Änderungen werden dabei gespeichert.",
      "ApproveUserTitle": "Benutzer freigeben",
      "DeactivateUserButtonText": "Benutzer deaktivieren",
      "DeactivateUserText": "Der Benutzer kann sich nicht mehr anmelden, alle Daten bleiben aber im Hintergrund unverändert bestehen. Sie können ihn jederzeit reaktivieren.",
      "DeactivateUserTitle": "Benutzer deaktivieren",
      "DeleteUserRequestButtonText": "Löschen",
      "DeleteUserRequestText": "Der Benutzer und alle zugehörigen Daten werden dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
      "DeleteUserRequestTitle": "Benutzeranfrage löschen",
      "EditUser": "Benutzer bearbeiten",
      "ExcelExportGdpr": "Excel-Export mit Personendaten",
      "ExcelExportGdprText": "Der Export enthält Personendaten aller Benutzer und unterliegt dem Datenschutz (DSG/DSGVO). Die Datei ist vertraulich zu behandeln, darf nicht an Unberechtigte weitergegeben werden und ist zu löschen, sobald sie nicht mehr benötigt wird. Soll der Export gestartet werden?",
      "Header": "Benutzerverwaltung",
      "NotifyUserByEmail": "Benutzer per E-Mail benachrichtigen",
      "PendingHeader": "Benutzeranfragen",
      "ReactivateUser": "Benutzer reaktivieren",
      "ReactivateUserText": "<p>Durch das Reaktivieren des Benutzers werden folgende Aktionen ausgelöst:</p><ul><li>Der Benutzer kann sich ab sofort wieder einloggen.</li><li>Nach dem Login kann er wieder auf alle Funktionen zugreifen.</li><li>Offene Offertenanfragen erscheinen wieder in den entsprechenden Listen.</li></ul>",
      "ReadOnlyUser": "Benutzer schreibgeschützt",
      "ReadOnlyUserText": "Der Benutzer ist mehreren Klinik-Gruppen zugewiesen und kann deshalb nicht bearbeitet werden. Wenden Sie sich bei Fragen an healthinal."
    },
    "Patients": {
      "AddPatient": "Patient hinzufügen",
      "DeletePatient": "Patient löschen",
      "DeletePatientText": "Soll dieser Patient wirklich gelöscht werden?",
      "EditPatient": "Patient bearbeiten",
      "Errors": {
        "CityRequired": "Bitte geben Sie den Ortsnamen ein",
        "DateOfBirthRequired": "Bitte geben Sie das Geburtsdatum ein",
        "FirstNameRequired": "Bitte geben Sie den Vornamen ein",
        "GenderRequired": "Bitte wählen Sie das Geschlecht aus",
        "LastNameRequired": "Bitte geben Sie den Nachnamen ein",
        "PostalCodeRequired": "Bitte geben Sie die Postleitzahl ein"
      },
      "Header": "Meine Patienten"
    },
    "Profile": {
      "ChangePersonalInfo": "Name oder E-Mail ändern",
      "QrReferencePrefix": "QR Referenz Präfix",
      "QrReferencePrefixTooltip": "Falls Sie Referenznummern generieren wollen kann hier optional ein Präfix definiert werden",
      "SavedSuccessful": "Neue Benutzerdaten wurden gespeichert"
    },
    "SpecialistQualifications": "Validierte Fachtitel",
    "SpecialistQualificationsHint": "Diese Fachtitel sind extern validiert und werden bei Bedarf für die Auswahl des korrekten OKP-Faktors verwendet.",
    "SpecialistQualificationsNone": "Keine validierten Fachtitel vorhanden.",
    "UserContractNegativeList": {
      "Active": "Aktuell gesperrt",
      "NoHistory": "Noch nie auf einer Negativliste.",
      "Ongoing": "laufend",
      "OpenEnd": "unbefristet",
      "Past": "Frühere Sperren",
      "Planned": "Zukünftige Sperren",
      "Title": "Negativliste"
    },
    "UserStatus": {
      "Active": "Aktiv",
      "Deleted": "Deaktiviert",
      "PendingRequest": "Anfrage pendent"
    },
    "UserType": {
      "Delegate": "Stellvertretung",
      "InstitutionGroupAdmin": "Klinikgruppenadmin",
      "Insurance": "Versicherung",
      "NotClassified": "Nicht zugeordnet",
      "Physician": "Belegarzt"
    }
  }
}
